import Api from "~/service/Api";

class CountryRepository {
  fetch(query) {
    // Note the url points to the old phocoa countries api url.
    return Api.get("/countries", query);
  }
}

export default CountryRepository;
